import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { getModulesFormInputs } from "../model/modules.modal";
import { menuUrl } from "../modules-list/model/modules-list.constants";
import { editModulesApi } from "./modules-edit.component.service";
import ModulesEditTemplateComponent from "./modules-edit-template.component";
import { PRIMARY_KEY } from "@constants/app.constants";

const {
  ALERT_TYPES: { SUCCESS, ERROR },
  MODULES_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const ModulesEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleModulesSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct menu item payload
    let modulesPayload = {};
    for (let i = 0; i < values.length; i++) {
      modulesPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const modulesResponse = await editModulesApi(
      location?.state?.row[PRIMARY_KEY],
      modulesPayload
    );

    // INFO : check api response and show relevant alert message
    if (modulesResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: modulesResponse.message })
      );
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const templateModal = {
    formTriggers,
    formInputs: getModulesFormInputs({
      name: location?.state?.row?.name || "",
      slug: location?.state?.row?.slug || "",
      status: location?.state?.row?.status || "",
    }),
  };

  const templateEvents = {
    handleModulesSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <ModulesEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default ModulesEditComponent;
